module.exports = __webpack_public_path__ + "static/img/IE.b5b007be.svg";